module.exports = __webpack_public_path__ + "assets/img/td_img.68427f81.png";